import { ReactNode, useState } from 'react';
import { DataTableContext } from './DataTableContext';

export function DataTableContextProvider({ children }: { children: ReactNode }) {
  const [sortedColumnHeader, setSortedColumnHeader] = useState<string>();

  return (
    <DataTableContext.Provider value={{ sortedColumnHeader, setSortedColumnHeader }}>
      {children}
    </DataTableContext.Provider>
  );
}
